// FIXME: replace with typography
import styled from 'styled-components'

import COLORS from 'pared/constants/colors'
import { MOBILE_WIDTH } from 'pared/constants/styles'

import AdvancedFilter, {
  IPropsType as IAdvancedFilterPropsType,
} from '../advancedFilter'
import DateFilter, {
  ITempPropsType as ITempDateFilterPropsType,
} from '../dateFilter'
import GroupFilter, {
  IPropsType as IGroupFilterPropsType,
} from '../groupFilter'
import Badge, { IPropsType as IBadgePropsType } from './badge'
import useApi, { IApiKeyType } from './hooks/useApi'
import SubTitle, { IPropsType as ISubTitlePropsType } from './subTitle'

export interface IConfigsType {
  title?: string | IApiKeyType
  advancedFilter?: IAdvancedFilterPropsType[]
  badge?: IBadgePropsType['api']
  subTitle?: ISubTitlePropsType['api']
  // FIXME: rename it after separating title
  titleMargin?: string
}

interface IPropsType {
  first: boolean
  dateFilterConfigs?: ITempDateFilterPropsType
  groupFilterConfigs?: IGroupFilterPropsType
  advancedFilterConfigs?: IAdvancedFilterPropsType[]
  children: IConfigsType['title']
  badgeConfigs: IConfigsType['badge']
  subTitleConfigs: IConfigsType['subTitle']
  marginConfigs: IConfigsType['titleMargin']
}

const Container = styled.div<Pick<IPropsType, 'first'> & { margin?: string }>`
  ${({ first, margin }) => {
    if (margin) return `margin: ${margin};`

    if (!first) return ''

    return 'margin-bottom: 50px'
  }}
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  min-width: 800px;
  gap: 25px;
  font-family: Lexend-SemiBold;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  color: ${COLORS.Chalkboard};

  @media ${MOBILE_WIDTH} {
    min-width: initial;
  }
`

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 7px;
`

const Title = ({
  first,
  groupFilterConfigs,
  dateFilterConfigs,
  advancedFilterConfigs,
  children,
  badgeConfigs,
  subTitleConfigs,
  marginConfigs,
}: IPropsType) => {
  const { data, loading } = useApi(children)

  return (
    <Container first={first} margin={marginConfigs}>
      <TitleContainer>
        <Badge api={badgeConfigs}>{loading ? 'Loading ...' : data}</Badge>

        {!first ? null : (
          <FilterContainer>
            {!groupFilterConfigs ? null : (
              <GroupFilter {...groupFilterConfigs} />
            )}

            {!dateFilterConfigs ? null : <DateFilter {...dateFilterConfigs} />}
          </FilterContainer>
        )}

        {!advancedFilterConfigs ? null : (
          <FilterContainer>
            {advancedFilterConfigs.map((advancedFilterConfig) => (
              <AdvancedFilter
                {...advancedFilterConfig}
                key={advancedFilterConfig[`${advancedFilterConfig.type}Key`]}
              />
            ))}
          </FilterContainer>
        )}
      </TitleContainer>
      <SubTitle api={subTitleConfigs} />
    </Container>
  )
}

export default Title
